import type { QueryFunctionContext } from '@tanstack/react-query';
import { WorkspacesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { workspacesKeys } from './workspacesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof workspacesKeys.slugAvailability>>;

export const createFetchWorkspaceSlugAvailabilityQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, wsSlug }], signal }: TParams) =>
    call(() => cancelOnSignal(WorkspacesService.isSlugAvailable({ oid: organizationId, wsSlug }), signal));
